module.exports = __webpack_public_path__ + "img/dark_box3_bg.be04fa3e.png";